/**
 * Petits outils partagés des écrans « Alertes & zones » et « Boîtiers GPS » (0052).
 *
 * Toutes les écritures passent par `ecrire` : en aperçu de développement (données fictives, aucune session) rien n'est
 * envoyé et on le dit ; sinon l'erreur de la base ou de l'edge function est rendue en phrase lisible dans le bandeau.
 */

export interface PourEcrire {
  apercu: boolean
  surNotifier: (message: string) => void
}

/** Exécute une écriture ; renvoie `true` si elle a abouti. `ok` = message de confirmation (ou aucun). */
export async function ecrire(p: PourEcrire, action: () => Promise<unknown>, ok?: string): Promise<boolean> {
  if (p.apercu) {
    p.surNotifier('Aperçu : rien n’est enregistré (données fictives).')
    return false
  }
  try {
    await action()
    if (ok) p.surNotifier(ok)
    return true
  } catch (e) {
    p.surNotifier(e instanceof Error ? e.message : String(e))
    return false
  }
}

/** Ajoute ou retire une valeur d'une liste (cases à cocher d'un groupe). */
export function basculer<T>(liste: readonly T[], v: T): T[] {
  return liste.includes(v) ? liste.filter((x) => x !== v) : [...liste, v]
}
